


















import Vue from 'vue';
import NavigationBar from './components/NavigationBar.vue';
import config from './config';

export default Vue.extend({
  name: 'app',
  data() {
    return {
      appName: config.appName,
    };
  },
  components: {
    NavigationBar,
  },
});
